import { createFileRoute } from '@tanstack/react-router';
import { ReportBuilderPage } from '@/features/analytics-reporting/ReportBuilderPage';

export const Route = createFileRoute('/_dashboard/dashboard/reporting/reports/new')({
  validateSearch: (search): { template?: string; source?: string } => ({
    template: typeof search.template === 'string' ? search.template : undefined,
    source: typeof search.source === 'string' ? search.source : undefined,
  }),
  component: NewAnalyticsReportPage,
});

function NewAnalyticsReportPage() {
  const { template, source } = Route.useSearch();
  return <ReportBuilderPage initialTemplate={template} sourceReportId={source} />;
}
